import { render } from "./TreeSelector.vue?vue&type=template&id=0fa7ef0b"
import script from "./TreeSelector.vue?vue&type=script&lang=js"
export * from "./TreeSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__